// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file message_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyResponseSchema } from "./empty_pb";
import { file_empty } from "./empty_pb";
import type { Message as Message$1 } from "./message_pb";
import { file_message } from "./message_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file message_service.proto.
 */
export const file_message_service: GenFile = /*@__PURE__*/
  fileDesc("ChVtZXNzYWdlX3NlcnZpY2UucHJvdG8SC2dycGMuYXBpLnYxIjsKElNlbmRNZXNzYWdlUmVxdWVzdBIlCgdtZXNzYWdlGAEgASgLMhQuZ3JwYy5hcGkudjEuTWVzc2FnZSIvChVQcmV2aWV3TWVzc2FnZVJlcXVlc3QSFgoObWVzc2FnZV9sb2dfaWQYASABKAUiSgoWUHJldmlld01lc3NhZ2VSZXNwb25zZRIPCgdzdWJqZWN0GAEgASgJEhEKCXBsYWludGV4dBgCIAEoCRIMCgRodG1sGAMgASgJMrcBCg5NZXNzYWdlU2VydmljZRJKCgtzZW5kTWVzc2FnZRIfLmdycGMuYXBpLnYxLlNlbmRNZXNzYWdlUmVxdWVzdBoaLmdycGMuYXBpLnYxLkVtcHR5UmVzcG9uc2USWQoOcHJldmlld01lc3NhZ2USIi5ncnBjLmFwaS52MS5QcmV2aWV3TWVzc2FnZVJlcXVlc3QaIy5ncnBjLmFwaS52MS5QcmV2aWV3TWVzc2FnZVJlc3BvbnNlQgZaBC47cGJiBnByb3RvMw", [file_empty, file_message]);

/**
 * @generated from message grpc.api.v1.SendMessageRequest
 */
export type SendMessageRequest = Message<"grpc.api.v1.SendMessageRequest"> & {
  /**
   * @generated from field: grpc.api.v1.Message message = 1;
   */
  message?: Message$1 | undefined;
};

/**
 * Describes the message grpc.api.v1.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest> = /*@__PURE__*/
  messageDesc(file_message_service, 0);

/**
 * @generated from message grpc.api.v1.PreviewMessageRequest
 */
export type PreviewMessageRequest = Message<"grpc.api.v1.PreviewMessageRequest"> & {
  /**
   * @generated from field: int32 message_log_id = 1;
   */
  messageLogId: number;
};

/**
 * Describes the message grpc.api.v1.PreviewMessageRequest.
 * Use `create(PreviewMessageRequestSchema)` to create a new message.
 */
export const PreviewMessageRequestSchema: GenMessage<PreviewMessageRequest> = /*@__PURE__*/
  messageDesc(file_message_service, 1);

/**
 * @generated from message grpc.api.v1.PreviewMessageResponse
 */
export type PreviewMessageResponse = Message<"grpc.api.v1.PreviewMessageResponse"> & {
  /**
   * @generated from field: string subject = 1;
   */
  subject: string;

  /**
   * @generated from field: string plaintext = 2;
   */
  plaintext: string;

  /**
   * @generated from field: string html = 3;
   */
  html: string;
};

/**
 * Describes the message grpc.api.v1.PreviewMessageResponse.
 * Use `create(PreviewMessageResponseSchema)` to create a new message.
 */
export const PreviewMessageResponseSchema: GenMessage<PreviewMessageResponse> = /*@__PURE__*/
  messageDesc(file_message_service, 2);

/**
 * @generated from service grpc.api.v1.MessageService
 */
export const MessageService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.MessageService.sendMessage
   */
  sendMessage: {
    methodKind: "unary";
    input: typeof SendMessageRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageService.previewMessage
   */
  previewMessage: {
    methodKind: "unary";
    input: typeof PreviewMessageRequestSchema;
    output: typeof PreviewMessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_message_service, 0);

